module.exports = __webpack_public_path__ + "images/landing/video-previews/success_preview_1_981_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/success_preview_1_981_2x.jpg
// module id = uQXu
// module chunks = 1